var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"click":function($event){return _vm.playAudio($event,_vm.audioUrl)}}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('v-btn',{attrs:{"icon":"","x-small":""}},[_c('v-icon',[_vm._v("mdi-music-note-eighth")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }